import React from 'react';
import {
  SimpleForm,
  TextInput,
  Restricted,
} from 'admin-on-rest';

import Edit from '../components/Edit';
import Section from './utils/Section';
import PinchoversityResults from './PinchoversityResults';


const ProfileComponent = (props) => (
  <SimpleForm {...props} redirect="edit">
    <Section title="contact">
      <TextInput source="fullName" options={{ autoComplete: 'new-fullName' }} />
      <TextInput source="email" type="email" options={{ autoComplete: 'new-email' }} />
    </Section>
    <PinchoversityResults {...props} />
  </SimpleForm>
);

const Profile = (props) => (
  <Restricted authParams={{ route: '/profile' }} location={props.location}>
    <Edit {...props}>
      <ProfileComponent {...props} />
    </Edit>
  </Restricted>
);

export default Profile;
